import { LegalClientConstitutionalDocumentEntity } from 'api/types/entity';

import { CompanyConstituentDocsFormType } from '../../forms/companyConstituentDocs';

export const getInitialData = (
  constitutionalDocument?: LegalClientConstitutionalDocumentEntity
): CompanyConstituentDocsFormType | undefined => ({
  dateOfLastChange: constitutionalDocument?.dateOfLastChange,
  fileIds: constitutionalDocument?.files.map((file) => file.id) ?? [],
});
